const EndCurrentSessionContent = () => {
  return null;
};

export default EndCurrentSessionContent;
